import React, { useMemo, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RefreshCw } from "lucide-react";
import { signatureservice } from "@/services/upload-service";

const UploadStamp: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [fsubcompanyCode, setSubcompanyCode] = useState("");
  const [fsigtype, setSigtype] = useState("");
  const [fstate, setState] = useState("");
  const [fimgstamp, setImgstamp] = useState<File | null>(null);
  const [apiresponse, setApiresponse] = useState("");

  const onSelectFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] ?? null;
    setImgstamp(file);
  };

  const canSubmit = useMemo(() => {
    return (
      fsubcompanyCode.trim().length > 0 &&
      fsigtype.trim().length > 0 &&
      fstate.trim().length > 0 &&
      !!fimgstamp
    );
  }, [fsubcompanyCode, fsigtype, fstate, fimgstamp]);

  const handleUpload = async () => {
    setLoading(true);
    setApiresponse("");

    const formData = new FormData();
    formData.append("subCompanyCode", fsubcompanyCode.trim());
    formData.append("sigType", fsigtype.trim());
    formData.append("state", fstate.trim());
    if (fimgstamp) formData.append("imageStamp", fimgstamp);

    try {
      const res = await signatureservice.createstamp(formData);
      if (res.status === 200) setApiresponse("Success");
      else setApiresponse("Upload Failed");
    } catch (err: any) {
      const msg =
        err?.response?.data?.errorMessage ||
        err?.response?.data ||
        "Upload Failed";
      setApiresponse(msg);
    } finally {
      setLoading(false);
    }
  };

  const responseClass =
    apiresponse.toLowerCase().includes("success")
      ? "text-green-700"
      : "text-red-700";

  return (
    <div className="w-full px-6 py-6">
      <h1 className="text-2xl font-semibold text-blue-700 mb-6">
        Upload Stamp Utility
      </h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 w-full">
        <div className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="subCompanyCode">SubCompany Code *</Label>
            <Input
              id="subCompanyCode"
              maxLength={3}
              value={fsubcompanyCode}
              onChange={(e) => setSubcompanyCode(e.target.value)}
              placeholder="Enter Subcompany Code"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="sigType">Sig Type *</Label>
            <Input
              id="sigType"
              maxLength={30}
              value={fsigtype}
              onChange={(e) => setSigtype(e.target.value)}
              placeholder="Enter Sig Type"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="state">State *</Label>
            <Input
              id="state"
              maxLength={4}
              value={fstate}
              onChange={(e) => setState(e.target.value)}
              placeholder="Enter State"
            />
          </div>
        </div>

        <div className="space-y-6">
          <div className="space-y-2 max-w-2xl">
            <Label htmlFor="stampFile">Stamp File *</Label>
            <Input id="stampFile" type="file" onChange={onSelectFile} />
          </div>
        </div>
      </div>

      <div className="mt-6 flex items-center gap-4">
        <Button
          disabled={!canSubmit || loading}
          onClick={handleUpload}
          className="min-w-[180px] gap-2"
        >
          {loading ? <RefreshCw className="h-4 w-4 animate-spin" /> : null}
          Upload
        </Button>

        {apiresponse ? (
          <span className={`text-sm font-medium ${responseClass}`}>
            {apiresponse}
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default UploadStamp;
